var _rect, _rect2, _circle, _path, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiImageGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 800,
    height: 800,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 340,
    height: 260,
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 300,
    height: 220,
    rx: 10,
    fill: "#ffffff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 170,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 320 L170 200 L250 260 L340 160 L360 320 Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 420,
    r: 72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 375 L400 465",
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355 420 L445 420",
    stroke: "#ffffff",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiImageGen);
export default __webpack_public_path__ + "static/media/aiImageGen.aafc3b22a590ac486c5cbe27aab29828.svg";
export { ForwardRef as ReactComponent };